export default __webpack_public_path__ + "static/media/avatar-ask-abe.9bb17ba9.svg";